import React from 'react';
import { Link } from 'react-router-dom';
// ESTA ES LA RUTA CORREGIDA. Desde 'components', subimos un nivel a 'src' y luego entramos a 'stylesheets'
import '../stylesheets/footer.css'; 

// Importamos los logos (asegúrate que la ruta sea correcta)
import logoIcetex from '../img/ICETEX-TRANSPARENTE.png';
import logoGovCo from '../img/gov-co.png';

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="footer-container">
        <div className="footer-column">
          <div className="footer-logos">
            <img src={logoIcetex} alt="Logo ICETEX" className="logo-icetex" />
            <img src={logoGovCo} alt="Logo Gobierno de Colombia" className="logo-govco" />
          </div>
          <p className="slogan">Invertimos en el talento de los colombianos</p>
        </div>

        <div className="footer-column">
          <h3>Sede Principal</h3>
          <p>
            Carrera 3 No. 18-32 <br />
            Bogotá D.C., Cundinamarca <br />
            Código postal: 111711
          </p>
          <h3>Líneas de Atención</h3>
          <p>
            Call Center: <a href="tel:+573336025656">(+57) 333 6025656</a> <br />
            Línea Nacional Gratuita: <a href="tel:018000916821">018000-916821</a>
          </p>
          <p style={{ marginTop: '10px' }}>
            <Link to="/canales-de-atencion/" style={{ color: '#fff', textDecoration: 'underline' }}>
              Ver todos los canales →
            </Link>
          </p>
        </div>

        <div className="footer-column">
          <h3>Enlaces de Interés</h3>
          <ul>
            <li><a href="https://web.icetex.gov.co/web/portal/el-icetex/normatividad/politicas-lineamientos-y-manuales" target="_blank" rel="noopener noreferrer">Políticas</a></li>
            <li><Link to="/red-de-oficinas/">Red de oficinas</Link></li>
            <li><Link to="/canales-de-atencion/">Canales de atención</Link></li>
            <li><Link to="/terminos-y-condiciones/">Términos y condiciones</Link></li>
            <li><Link to="/mapa-del-sitio/">Mapa del sitio</Link></li>
          </ul>
        </div>

        <div className="footer-column">
          <h3>Síguenos</h3>
          <div className="social-links">
            <a href="https://www.facebook.com/ICETEXCOLOMBIA" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 24 24"><path fill="currentColor" d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path></svg>
            </a>
            <a href="https://twitter.com/ICETEX" aria-label="Twitter" target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 24 24"><path fill="currentColor" d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"></path></svg>
            </a>
            <a href="https://www.instagram.com/icetex_colombia/" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 24 24"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path fill="currentColor" d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"></path></svg>
            </a>
            <a href="https://www.linkedin.com/company/icetex" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 24 24"><path fill="currentColor" d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM6 9H2V21h4zM4 2a2 2 0 100 4 2 2 0 000-4z"></path></svg>
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© 2026 ICETEX. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;